import { Button } from '@madpaws/design-system';

import styles from './StickyMobileEditSearch.module.css';
import { AdvancedFiltersMainDialog } from '../../AdvancedSearch/AdvancedFilters/AdvancedFiltersMainDialog';
import { AdvancedFiltersMinReviewsDialog } from '../../AdvancedSearch/AdvancedFilters/AdvancedFiltersMinReviewsDialog';
import { AdvancedFiltersPriceDialog } from '../../AdvancedSearch/AdvancedFilters/AdvancedFiltersPriceDialog';

import type { ReactElement } from 'react';

type Props = {
  handleScrollToFilters: () => void;
  isLoading: boolean;
  onEditSearch: () => void;
  onSubmit: () => void;
};

const StickyMobileEditSearch = ({ isLoading, onSubmit, onEditSearch }: Props): ReactElement => (
  <div className={styles.root}>
    <div>
      <Button isFullBleed label="Edit Search" onClick={onEditSearch} size="small1x" />
    </div>
    <div className={styles.filters}>
      <AdvancedFiltersMainDialog
        handleAdvancedFiltersSubmit={onSubmit}
        isLoading={isLoading}
        isPriceSliderShown
        isReviewFilterEnabled
      />
      <AdvancedFiltersPriceDialog handleAdvancedFiltersSubmit={onSubmit} isLoading={isLoading} />
      <AdvancedFiltersMinReviewsDialog
        handleAdvancedFiltersSubmit={onSubmit}
        isLoading={isLoading}
      />
    </div>
  </div>
);

export { StickyMobileEditSearch };
